import { useState, useEffect } from 'react';
import { ErrorIcon } from '../common/Icons';
//import { apiClient } from '../../utils/api';
import { pgApi } from '../../utils/pgApi';

function DeviceDropdown({ selectedDevice, onDeviceChange }) {
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadDevices = async () => {
            try {
                setLoading(true);
                const data = await pgApi.listDevices();
                setDevices(Array.isArray(data) ? data : []);

                setError(null);
            } catch (err) {
                console.error('Error loading devices:', err);
                setError(err.message);
                setDevices([]);
            } finally {
                setLoading(false);
            }
        };

        loadDevices();
    }, []);

    if (loading) {
        return (
            <div className="device-dropdown">
                <label>DEVICE:</label>
                <select disabled>
                    <option>Loading devices...</option>
                </select>
            </div>
        );
    }

    if (error) {
        return (
            <div className="device-dropdown">
                <label>Device:</label>
                <select disabled>
                    <option><ErrorIcon />Error loading devices: {error}</option>
                </select>
            </div>
        );
    }

    const deviceList = Array.isArray(devices) ? devices : [];

    const formatDeviceDisplay = (device) => {
        const mac = device.mac || 'Unknown MAC';
        const model = device.model || 'Unknown Model';
        const userId = device.user_id || 'Unknown User';
        const location = device.location;

        let displayText = `${mac} - ${model} (User: ${userId})`;

        if (location) {
            displayText += ` [${location}]`;
        }

        return displayText;
    };

    return (
        <div className="device-dropdown">
            <label htmlFor="device-select">DEVICE:</label>
            <select id="device-select" value={selectedDevice} onChange={(e) => onDeviceChange(e.target.value)}>
                <option value="">Select a device...</option>
                {deviceList.map((device) => (
                    <option key={device.mac || device.device_id} value={device.device_id || device.mac}>
                        {formatDeviceDisplay(device)}
                    </option>
                ))}
            </select>
            {deviceList.length === 0 && (
                <p className="device-dropdown__empty">No devices available</p>
            )}
        </div>
    );
}

export default DeviceDropdown;